"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _TargetGrants_1 = require("./_TargetGrants");
exports._LoggingEnabled = {
    type: "structure",
    required: ["TargetBucket", "TargetPrefix"],
    members: {
        TargetBucket: {
            shape: {
                type: "string"
            }
        },
        TargetGrants: {
            shape: _TargetGrants_1._TargetGrants
        },
        TargetPrefix: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_LoggingEnabled.js.map